import { UserApi } from './user'
import {StationApi} from './station'
export default {
  ...UserApi,
  ...StationApi
}
